import { TransferAccount } from '@ally/data-types-transfer-accounts'
import {
  isInvest,
  isExternal,
  getAccountId,
} from '@ally/transfer-account-utils'

export interface TransferSelectionFlags {
  showRestOfForm: boolean
  showInvestTransferMessage: boolean
  showBankLink: boolean
}

export function getTransferSelectionFlags(
  accounts: TransferAccount[],
  fromAccount: string,
  toAccount: string,
): TransferSelectionFlags {
  const fromAccountIsInvest = accounts.some(
    account => getAccountId(account) === fromAccount && isInvest(account),
  )
  const toAccountIsInvest = accounts.some(
    account => getAccountId(account) === toAccount && isInvest(account),
  )
  const investAccountSelected = fromAccountIsInvest || toAccountIsInvest
  const investToInvestSelected = fromAccountIsInvest && toAccountIsInvest
  const externalAccountSelected = accounts.some(
    account =>
      (getAccountId(account) === fromAccount ||
        getAccountId(account) === toAccount) &&
      isExternal(account),
  )

  return {
    showRestOfForm: !!(fromAccount && toAccount) && !investAccountSelected,
    showInvestTransferMessage: investAccountSelected,
    showBankLink:
      investAccountSelected &&
      !externalAccountSelected &&
      !investToInvestSelected,
  }
}
